export default __webpack_public_path__ + "static/media/mental-health-commission-logo.537cca79.svg";